import { CSSObject, MantineTheme } from '@mantine/core';
import { MantineThemeComponent } from '../../types';
import { textVariants } from '../../tokens/typography/typography';

const FileInputDefaultConfig: MantineThemeComponent = {
	defaultProps: {},
	styles: ( theme: MantineTheme ) => ( {
		input: {
			...( textVariants.footnote as CSSObject ),
			background: theme.fn.themeColor( 'gray.0' )
		},
		placeholder: {
			...( textVariants.footnote as CSSObject ),
			color: `${theme.fn.themeColor( 'dark.2' )} !important`
		},
		icon: {
			color: theme.fn.themeColor( 'dark.2' )
		}
	} )
};

export default FileInputDefaultConfig;
